export const SHOT_GET_ALL = 'SHOT_GET_ALL';
export const SHOT_SAVE = 'SHOT_SAVE';
export const SHOT_EDIT = 'SHOT_EDIT';
export const SHOT_DELETE = 'SHOT_DELETE';